import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ReadState, RequestReadState } from '@atlassian/notification-common/types';
import { markAllApiRoute, markAllNotificationsReadFetch as markAllAsRead } from '../../../../utils/mark-all-client';
/**
 * Updates the state of all notification groups to read.
 */
export var markAllGroupsAsRead = function markAllGroupsAsRead(isDirect, readStateFilter, handlers, filters) {
  return function (_ref) {
    var _groups$;
    var getState = _ref.getState,
      setState = _ref.setState;
    var groups = getState().groups;
    var headNotification = (_groups$ = groups[0]) === null || _groups$ === void 0 ? void 0 : _groups$.notifications[0];
    if (headNotification) {
      markAllAsRead(isDirect, headNotification.id, filters).then(function (_) {
        return handlers.onSuccess(markAllApiRoute);
      }).catch(function (e) {
        return handlers.onError(e.code);
      });
    }
    if (readStateFilter === RequestReadState.UNREAD) {
      setState({
        groups: []
      });
      return;
    }
    setState({
      groups: groups.map(function (group) {
        return _objectSpread(_objectSpread({}, group), {}, {
          readStates: [ReadState.READ],
          notifications: group.notifications.map(function (notification) {
            return _objectSpread(_objectSpread({}, notification), {}, {
              readState: ReadState.READ
            });
          })
        });
      })
    });
  };
};